import React from "react";
import { FaBan, FaTrash } from "react-icons/fa";
import api from "../../../../services/api";

const CardBloqueio = ({ inicio, fim, recorrencia, id, onDeleteSuccess }) => {
  const handleDeletePress = async (id) => {
    if (!window.confirm("Deseja realmente excluir este bloqueio?")) return;

    try {
      const response = await api.delete(`/bloqueio-agenda/${id}`);
      if (response.status === 200) {
        onDeleteSuccess(); // Atualiza a lista
        alert("Bloqueio excluído com sucesso");
      } else {
        alert("Houve um erro ao excluir o bloqueio");
      }
    } catch (error) {
      alert("Houve um erro ao conectar ao servidor");
    }
  };

  return (
<div className="w-[95%] max-w-md rounded-md border border-gray-300 bg-gray-50 p-4 flex justify-between items-center">
  <div className="flex items-center gap-4">
    <FaBan className="text-red-500 w-6 h-6" />
    <div className="flex flex-col">
      <span className="font-bold text-gray-800">Informações</span>
      <span className="text-gray-700">Início: {inicio}</span>
      <span className="text-gray-700">Fim: {fim}</span>
      <span className="text-gray-700">Recorrência: {recorrencia}</span>
    </div>
  </div>

  <button
    onClick={() => handleDeletePress(id)}
    className="text-white hover:text-red-500 transition-colors w-12 h-12 flex items-center justify-center"
  >
    <FaTrash />
  </button>
</div>


  );
};

export default CardBloqueio;
